import classNames from 'classnames';
import {
  CircleNotchIcon,
} from '@/ui/icons';

import styles from './Loader.module.css';

type LoaderProps = {
  color?: 'neutral' |
          'neutral-50' |
          'neutral-100' |
          'neutral-200' |
          'neutral-500' |
          'neutral-600' |
          'neutral-800' |
          'primary-50' |
          'primary-200' |
          'primary-500' |
          'primary-600' |
          'primary-700' |
          'danger' |
          'warning';
  overlay?: boolean;
  className?: string;
}

const Loader = (props: LoaderProps) => {
  const {
    overlay = false,
    color = 'primary-600',
    className,
  } = props;

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const loaderClassName = classNames({
    [styles.loader]: true,
    [styles.overlay]: overlay,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className={loaderClassName}>
      {overlay && (
        <div className={styles.overlay} />
      )}

      <div className={styles.spin}>
        <CircleNotchIcon color={`var(--${color})`} />
      </div>
    </div>
  );
};

export default Loader;
export type { LoaderProps };
